/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Backfill_WriteInputs */



/**
* | output |
* | --- |
* | "Start and stop history imports" |
*
* @param {Perm_Product_Backfill_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_backfill_write = /** @type {((inputs?: Perm_Product_Backfill_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Backfill_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запускать и останавливать импорт истории")
	return /** @type {LocalizedString} */ ("Start and stop history imports")
});